<!-- MIGAS DE PAN Y TÍTULO -->
<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="bg-second-migas">
  <div class="container mt-cab-fixed">
    <div class="pre-content">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Adheridos</li>
          <li class="breadcrumb-item active"><a>Búsqueda declaración envases</a></li>
        </ol>
      </nav>
      <div class="content-title">
        <h2 class="title-pag">Búsqueda declaración envases</h2>
        <!-- <button *ngIf="this.authService.can('dec_envases', 'create')" (click)="confirmacionCreacionDeclaracion()"
          type="button" class="btn btn-primary" data-toggle="modal"><span class="icon-add"></span>Nueva
          declaración</button> -->
      </div>
    </div>
  </div>
</div>

<!-- FIN MIGAS DE PAN Y TÍTULO -->

<!-- CONTENIDO - FICHA -->
<div class="container-form">
  <!-- Barra de filtros aplicados -->
  <div class="filtros-bar">
    <div class="filtros-aplicados">
      <span class="filtros-label">Filtros aplicados</span>
      <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
        {{filtro.label}}
        <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
      </span>
    </div>
    <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
      <mat-icon>tune</mat-icon>
      {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
    </button>
  </div>
  <!-- Formulario de búsqueda -->
  <form *ngIf="mostrarFiltros" class="container form-search py-3 padding-form" [formGroup]="searchForm">
    <div [ngClass]="{'combined-rows': !canViewResource('DE-ENV-GEST')}">
    <div class="row-fields">
      <div class="field field-grow" *ngIf="!canViewResource('DE-ENV-GEST')">
        <label for="adherido">Adherido</label>
        <mat-form-field appearance="outline" class="custom-mat-form-field">
          <mat-select formControlName="adherido" id="adherido" placeholder="Adherido" multiple>
            <mat-option *ngFor="let adherido of adheridosAll" [value]="adherido.id">
              {{adherido.razonSocial}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field field-20" *ngIf="canViewResource('DE-ENV-GEST')">
          <label for="idadherido" >ID. Adherido </label>
          <div class="custom-mat-field" >
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idadherido" id="idadherido" placeholder="ID. Adherido" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
      </div>
      <div class="field" *ngIf="canViewResource('DE-ENV-GEST')" style="flex: 2 1 300px;">
        <label for="adherido" class="bottom">Razón Social Adherido</label>
        <lib-ge-select-pagination (selectedModel)="selectedModel()" [endPointFilter]="adheridosEndpoint" [multiple]=true
          (filteredList)="filterList($event)" [updateList]="updateList" [disabled]="flagDisabledForm"
          [placeHolder]="'--Razón Social Adheridos--'" [formControlNameSelect]="getFormControl('adherido')"
          [objQueryName]="'razonSocial'" descripcion="razonSocial">
        </lib-ge-select-pagination>
      </div>
      <div class="field field-grow" *ngIf="canViewResource('DE-ENV-GEST')">
          <label for="estadoAdherido">Estado adherido </label>
          <div class="custom-mat-field">
               <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estadosAdherido" id="estadosAdherido" placeholder="--Estado adherido--" multiple>
                <mat-option *ngFor="let estado of estadosAdherido" [value]="estado.id">
                  {{estado.descripcion_corta}}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estadosAdherido')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estadosAdherido')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
      </div>
            <div class="field field-grow">
        <label for="anio">Año de los datos</label>
        <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
          <input matInput type="number" formControlName="anio" id="anio" placeholder="Año de los datos">
        </mat-form-field>
      </div>
       </div>
    </div>
    <div class="row-fields">
        <div class="field flex-grow-1" *ngIf="canViewResource('DE-ENV-GEST')">
          <label for="codigoDeclaracion">Código Declaración </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigoDeclaracion" id="codigoDeclaracion" placeholder="Código Declaración" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="field field-grow" *ngIf="canViewResource('DE-ENV-GEST')">
          <label for="versionDeclaracion">Versión de declaración</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="versionDeclaracion" id="versionDeclaracion" placeholder="--Versión de Declaración--">
                <mat-option *ngFor="let version of versionesDAE" [value]="version.id">
                    {{version.descripcion}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-grow" *ngIf="canViewResource('DE-ENV-GEST')">
          <label for="tipoDeclaracion">Tipo de declaración</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoDeclaracion" id="tipoDeclaracion" placeholder="--Tipo de Declaración--">
                <mat-option *ngFor="let tipo of tiposDAE" [value]="tipo.valor">
                    {{tipo.tipo}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      <div class="field field-grow">
        <label for="estado">Estado declaración</label>
        <mat-form-field class="custom-mat-form-field mt-1" appearance="outline">
          <mat-select formControlName="estadoDeclaracion" id="estadoDeclaracion" placeholder="--Estado declaración--" multiple>
            <mat-option *ngFor="let estado of estados" [value]="estado.id">
              {{estado.descripcion}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field field-grow" *ngIf="!canViewResource('DE-ENV-GEST')" >
          <label for="tipoDeclaracion">Tipo de declaración</label>
             <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="tipoDeclaracion" id="tipoDeclaracion" placeholder="--Tipo de Declaración--">
                  <mat-option *ngFor="let tipo of tiposDAE" [value]="tipo.valor">
                     {{tipo.tipo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
      </div>
            <div class="d-flex gap-3" style="flex: 0 0 auto;" *ngIf="this.authService.can('dec_envases', 'access-facturar')">
              <div class="d-flex flex-column" style="width: 220px;">
                <label for="aFacturar">A facturar</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                  <mat-select formControlName="afacturar" id="aFacturar" placeholder="Seleccionar">
                    <mat-option *ngFor="let item of optionArray" [value]="item.value">
                      {{ item.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex flex-column" style="width: 220px;">
                <label for="facturada">Facturada</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                  <mat-select formControlName="facturada" id="facturada" placeholder="Seleccionar">
                    <mat-option *ngFor="let item of optionArray" [value]="item.value">
                      {{ item.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
                      <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('DE-ENV-GEST') ||  this.canViewResource('DE-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('DE-ENV-GEST') ||  this.canViewResource('DE-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
<mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
            </div>
    </div>
    </div>

    <!--<div class="row-fields">

      <div class="field flex-grow-1" *ngIf="this.authService.can('dec_envases', 'access-facturar')"></div>

      <div class="field flex-grow-1" *ngIf="this.authService.can('dec_envases', 'access-facturar')">
            <label for="aFacturar">A facturar</label>
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="afacturar" id="aFacturar" placeholder="Seleccionar">
                <mat-option *ngFor="let item of optionArray" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
      </div>
      <div-- class="field flex-grow-1" *ngIf="this.authService.can('dec_envases', 'access-facturar')">
            <label for="facturada">Facturada</label>
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="facturada" id="facturada" placeholder="Seleccionar">
                <mat-option *ngFor="let item of optionArray" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div-->

     <!--<div class="field flex-grow-1" *ngIf="this.authService.can('dec_envases', 'access-facturar')"></div>

    </div>-->

  </form>
      <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
  <!-- FIN Formulario de búsqueda -->
</div>
<div class="bg-second-table-info pt-3 pb-5 ">
  <div *ngIf="flagSearch; else messageClear" class="container">
    <div class="actions-table">
      <div class=""><span class="align-middle tit-table">{{recordsTotal}} registros encontrados</span></div>
      <div class="botones-tabla">
        <div class="d-inline" *ngIf="canViewResource('DE-ENV-GEST')">
          <div class="dropdown show">
            <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
              (click)="declaracionesAFacturar()">
              <span>Declaraciones para facturar</span></a>
          </div>
        </div>
        <div class="d-inline" *ngIf="canViewResource('DE-ENV-GEST')">
          <div class="dropdown show">
            <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
              (click)="marcarDeclaracionesFacturadas()">
              <span>Marcar como facturadas</span></a>
          </div>
        </div>
        <div class="d-inline" *ngIf="canViewResource('DE-ENV-GEST')">
          <div class="dropdown show">
            <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
              (click)="generarDaeDefinitiva()">
              <span>Generar DAE definitiva</span></a>
          </div>
        </div>
        <div class="d-inline" *ngIf="this.authService.can('dec_envases', 'access-facturar')">
          <div class="dropdown show">
            <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
              (click)="abrirModalInforme()">
              <span>Informe facturación</span></a>
          </div>
        </div>
        <div class="d-inline" *ngIf="canAccessExport()">
          <div class="dropdown show">
            <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
              (click)="exportarCsv()">
              <span>Exportar</span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="card-tabla-proy">
      <div class="card-body">
        <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
          <div class="datatable-container table-responsive">
            <!-- TABLA Listado con resultados de búsqueda -->
            <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
              (actionButton)="action($event)" (sort)="sortGrid($event)"></lib-ge-table>
            <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
              <div class="d-flex mt-2">
                <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                  (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                </ngb-pagination>
              </div>

              <div class="mt-2 selectPage">
                <label for="itemsPerPage">Mostrar:</label>
                <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                  <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <!-- FIN TABLA Listado con resultados de búsqueda -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #messageClear>
    <div class="mensaje-container">
      <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el formulario.</p>
    </div>
  </ng-template>
</div>


<!-- FIN CONTENIDO -->
